'use client'

import SettingsIcon from '@/assets/icons/settings.svg'
import TransferIcon from '@/assets/icons/transfer.svg'
import WalletIcon from '@/assets/icons/wallet.svg'
import { ROUTES } from '@/core/constants/routes'
import { Stepper } from '@/core/ui/components/stepper'
import { usePathname } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

const useTripDetails = () => {
  const pathname = usePathname()
  const segments = pathname.split('/').slice(2)
  let paymentStatus = 'pending'
  let step = 0

  if (segments.length === 1) {
    return { step, payment: paymentStatus, tripId: null }
  }

  const [tripId, path] = segments
  if (
    ROUTES.payTrip(tripId)
      .split('/')
      .some(v => v === path)
  ) {
    step = 1
  }
  if (
    ROUTES.tripPaymentFailed(tripId)
      .split('/')
      .some(v => v === path)
  ) {
    paymentStatus = 'failed'
    step = 2
  }
  if (
    ROUTES.tripPaymentSucceed(tripId)
      .split('/')
      .some(v => v === path)
  ) {
    step = 2
    paymentStatus = 'success'
  }
  return {
    step,
    payment: paymentStatus,
    tripId,
  }
}

export const CreateTripStepper = () => {
  const t = useTranslations()
  const { payment, step, tripId } = useTripDetails()
  const steps = [
    {
      label: t('trip.prepareTitle'),
      icon: <SettingsIcon />,
      link: ROUTES.reservation,
    },
    {
      label: t('trip.transferTitle'),
      icon: <TransferIcon />,
      link: ROUTES.payTrip(tripId || ''),
    },
    {
      label: t('trip.paymentTitle'),
      icon:
        payment === 'failed' ? (
          <div className='border-red bg-red z-10 flex h-full w-full items-center justify-center rounded-full border p-5 text-2xl text-white'>
            &#x2715;
          </div>
        ) : (
          <WalletIcon />
        ),
      link:
        payment === 'failed'
          ? ROUTES.tripPaymentFailed(tripId || '')
          : ROUTES.tripPaymentSucceed(tripId || ''),
    },
  ]
  return <Stepper activeStep={step} steps={steps} canBack={step < 2} />
}
